import type * as mdast from 'mdast';

import { BLOCK_INTEGRATION, type BlockIntegrationData } from '@gitbook/doc-core';
import type { Block } from '@gitbook/slate';

import { lookupIntegrationBlockInSet } from '../../utils';
import { createCustomBlock, formatCustomProperties } from './compiler-custom-blocks';
import type { GastToMdastTransformMap } from './types';

/**
 * Convert an integration block into Markdown nodes.
 */
export const transformIntegrationBlocks: GastToMdastTransformMap<Block> = {
    [BLOCK_INTEGRATION]: async (node: Block, _eat, options) => {
        const data = node.data.toObject<BlockIntegrationData>();

        const integrationBlock = lookupIntegrationBlockInSet(
            options.integrationBlocks || {},
            (entry) => {
                return entry.integrationKey === data.integration && entry.block.id === data.block;
            }
        );

        // Formatting as a code-block
        if (integrationBlock?.block.markdown) {
            const { [integrationBlock.block.markdown.body]: body, ...restProps } = data.props;

            const codeBlock: mdast.Code = {
                type: 'code',
                lang: integrationBlock.block.markdown.codeblock,
                meta: formatCustomProperties({
                    ...restProps,
                    ...(typeof data.fullWidth !== 'undefined'
                        ? { fullWidth: `${Boolean(data.fullWidth)}` }
                        : undefined),
                }),
                value: body,
            };

            return [codeBlock];
        }

        // Default formatting
        return [
            createCustomBlock(
                `@${data.integration}/${data.block}`,
                {
                    ...data.props,
                    ...(typeof data.fullWidth !== 'undefined'
                        ? { fullWidth: `${Boolean(data.fullWidth)}` }
                        : undefined),
                },
                []
            ),
        ];
    },
};
